import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgBookmarkCheck = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 20,
	height: 20,
	viewBox: "0 0 19 19",
	fill: "none",
	...props,
	children: [/* @__PURE__ */ _jsx("mask", {
		id: "mask0_397_29301",
		style: { maskType: "alpha" },
		maskUnits: "userSpaceOnUse",
		x: 0,
		y: 0,
		width: 20,
		height: 20,
		children: /* @__PURE__ */ _jsx("rect", {
			width: 20,
			height: 20,
			fill: "#D9D9D9"
		})
	}), /* @__PURE__ */ _jsx("g", {
		mask: "url(#mask0_397_29301)",
		children: /* @__PURE__ */ _jsx("path", {
			d: "M9.12516 11.37L12.9537 7.5415L12.0627 6.66338L9.12516 9.6088L7.93766 8.4213L7.04662 9.31234L9.12516 11.37ZM4.5835 16.8748V4.42296C4.5835 4.00199 4.72933 3.64567 5.021 3.354C5.31266 3.06234 5.66898 2.9165 6.08995 2.9165H13.9104C14.3313 2.9165 14.6877 3.06234 14.9793 3.354C15.271 3.64567 15.4168 4.00199 15.4168 4.42296V16.8748L10.0002 14.5511L4.5835 16.8748ZM5.8335 14.9582L10.0002 13.1665L14.1668 14.9582V4.42296C14.1668 4.3588 14.1401 4.30005 14.0866 4.24671C14.0333 4.19324 13.9745 4.1665 13.9104 4.1665H6.08995C6.02579 4.1665 5.96704 4.19324 5.9137 4.24671C5.86023 4.30005 5.8335 4.3588 5.8335 4.42296V14.9582Z",
			fill: "currentColor"
		})
	})]
});
export default SvgBookmarkCheck;
